import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const LeaveTypeDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Leave Type"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Leave Type">
                {getFieldDecorator('leaveType', {
                 initialValue: data.leaveType,
                  rules: [{ required: true, message: 'Please input the Leave Type!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default LeaveTypeDialogForm;
